export const QUILL_DEFAULT_MODULES = {
  toolbar: [
    ['bold', 'italic', 'underline'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link'],
    ['clean'],
  ],
};

export const QUILL_DEFAULT_FORMATS = [
  'bold',
  'italic',
  'underline',
  'strike',
  'list',
  'indent',
  'image',
  'link',
];
